// ============================================================
// web/src/features/devis/gammeProposee.js — une gamme PROPOSÉE par
// l'agent devient la gamme de l'écran.
// ------------------------------------------------------------
// Deux gestes l'appliquent : « Réestimer » (`useDevisEditor`) et la
// révision par consigne (`DevisPage`). Ils recopiaient chacun les lignes
// à la main, et aucun des deux ne portait `temps_min_ia` — le temps de
// base proposé par l'IA n'apparaissait donc jamais avant un rechargement,
// et le premier enregistrement l'effaçait (15 septembre 2026 : vide sur
// les 211 lignes de la base).
//
// La règle est celle du serveur (`api/repositories/gammeHeritage.js`),
// décidée par Thibaud le 15 septembre : **le temps de base est la
// PREMIÈRE proposition, et il ne bouge plus.** Une ligne déjà présente
// garde le sien ; une ligne neuve prend ce que l'agent propose. Le
// serveur a le dernier mot à l'enregistrement — ceci ne sert qu'à ce que
// l'écran dise la même chose tout de suite.
// ============================================================

const cle = (op) => `${Number(op.op_num)}|${op.categorie}|${op.unite}`;

/**
 * @param {object[]} proposees  les lignes rendues par l'agent
 * @param {object[]} actuelles  la gamme affichée avant d'appliquer
 * @param {'ia'|'consigne'} source
 */
export function gammeProposee(proposees, actuelles = [], source = 'ia') {
  const files = new Map();
  for (const l of actuelles ?? []) {
    if (l?.temps_min_ia == null) continue;
    if (!files.has(cle(l))) files.set(cle(l), []);
    files.get(cle(l)).push(Number(l.temps_min_ia));
  }
  return (proposees ?? []).map((op) => {
    const base = files.get(cle(op))?.shift();
    return {
      id: null,
      op_num: op.op_num,
      // `prise_num` se DÉDUIT côté serveur depuis le 11 août.
      prise_num: op.prise_num ?? null,
      machine_id: op.machine_id ?? null,
      operation_id: null,
      libelle: op.libelle ?? null,
      detail: op.detail ?? null,
      entites: op.entites ?? [],
      temps_min: op.temps_min,
      temps_min_ia: base ?? (op.temps_min == null ? null : Number(op.temps_min)),
      unite: op.unite,
      categorie: op.categorie,
      justification: op.justification ?? null,
      programmation_incluse_min: op.programmation_incluse_min ?? null,
      source,
    };
  });
}
